import type {FileApiModel} from '../../../api/media/file';
import type {Nullable} from '../../utility-types';

export const getFileIcon = (file?: Nullable<FileApiModel>) => {
  if (file) {
    if (file.categories.includes('website')) {
      return require('../../../assets/icons/primary/Discovery.svg').default;
    }

    if (file.categories.includes('image')) {
      return require('../../../assets/icons/primary/Image.svg').default;
    }

    if (file.categories.includes('video')) {
      return require('../../../assets/icons/primary/Video.svg').default;
    }
  }

  return require('../../../assets/icons/primary/Document.svg').default;
};
